import SiteLoader from '@/components/Loaders/SiteLoader';
import SideBar from '@/components/sidebar';
import TrustNetworkPage from '../onboarding/trustNetworkPage';
import VideoGuideModal from '@/components/VideoGuide';
import { useSessionTimeout } from '@/utils/useSessionTimeout';

type Props = {
  children: JSX.Element;
  sidebarId?: number;
  path?: string;
};

const RequiresAuth = (props: Props) => {
  const { children, sidebarId } = props;
  // Call useSessionTimeout to handle session timeout
  useSessionTimeout();

  return (
    <div className="flex w-full h-screen overflow-auto">
      {sidebarId && sidebarId > -1 ? <SideBar activeNav={sidebarId ?? 0} /> : <></>}
      {children}
      <TrustNetworkPage />
      <VideoGuideModal />
      <SiteLoader />
    </div>
  );
};

export default RequiresAuth;
